/**
 * Weekly n8n guides reuse the same “custom cakes Barrie” template.
 * Google’s scaled content abuse policy covers that pattern.
 * Unique first-hand pages (no date stamp / mkz id) stay indexable.
 */

export function isScaledWeeklyGuideSlug(slug?: string | null): boolean {
  const value = String(slug || '').toLowerCase();
  if (!value) return false;
  if (/^nanny-bs-bakery-barrie-mkz/.test(value)) return true;
  // n8n slugs end with -YYYYMMDD plus an extra letter or digit.
  if (/-\d{8,9}[a-z]?$/.test(value)) return true;
  return false;
}

export function robotsForGuideSlug(slug?: string | null): string {
  return isScaledWeeklyGuideSlug(slug) ? 'noindex, follow' : 'index, follow';
}
